import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import loc from '../../utils/loc';
import Button from '../Button';
import State from '../../context';

const Pagination = ({ index, total, setCurrentQuestionIndex }) => {
  const state = useContext(State);

  const next = index < (total - 1) ? index + 1 : false;
  const prev = index > 0 ? index - 1 : false;

  return (
    <Wrapper>
      {typeof prev === 'number' ? <Button onClick={() => setCurrentQuestionIndex(prev)}>{loc.t('previous')}</Button> : <span />}
      {typeof next === 'number' ? <Button onClick={() => setCurrentQuestionIndex(next)}>{loc.t('next')}</Button> : <span />}
      {state.showPreResult ? <Button onClick={state.calculateResults} primary={true}>{loc.t('show results')}</Button> : null}
    </Wrapper>
  );
};

Pagination.propTypes = {
  index: PropTypes.number,
  total: PropTypes.number,
  setCurrentQuestionIndex: PropTypes.func,
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;
  margin-top: 1rem;
`;

export default Pagination;
